export enum HeatmapType {
    Hourly = 0,
    Shift,
}